<template>
    <div class="my-10">
        <LikedNav></LikedNav>
        <h1 class="font-bold text-xl gap-4 mb-4 hidden max-md:flex">{{ $t('nav.mediaLiked') }}</h1>
        <div class="grid grid-cols-4 max-lg:grid-cols-3 max-md:grid-cols-2">
            <template v-for="item in this.$store?.videoLiked" :key="item.id">
                <router-link :to="{ name: 'mediaDetail', params: { id: item.id } }">
                    <MediaCard :detail="item">
                    </MediaCard>
                </router-link>
            </template>
            
        </div>
        <div v-show="loading === true" class="flex justify-center mx-auto w-full" role="status">
            <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
            </IconSpinner>

            <span class="sr-only">Loading...</span>
        </div>
        <div v-show="this.$store?.videoLiked?.length === 0 && loading === false">
            <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_liked') }}</p>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import MediaCard from '@cmp/media/MediaCard.vue'
import LikedNav from '@cmp/profile/LikedNav.vue'
export default {
    name: 'mediaLiked',
    components: {
        MediaCard,
        LikedNav
    },
    data() {
        return {
            loading: false,
            videos: []
        }
    },
    methods: {
        
    },
    computed: {

    },
    created() {
    }
}

</script>
<style scoped>
.router-link-exact-active{
    border-bottom: 1px solid #409DBA;
    color: #000000;
}
</style>